"use strict";

exports.__esModule = true;
var _Grid = _interopRequireDefault(require("./Grid"));
exports.default = _Grid.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}